export default {"src":"/_next/static/media/profileDots.f1f78072.svg","height":14,"width":4,"blurWidth":0,"blurHeight":0};